import { Suspense, lazy } from 'react';

import { useTheme } from '@pulse-web-ui/theme';

import {
  BulletIcon,
  Hint,
  IconContainer,
} from './field-validation-hint.styles';
import { FieldValidationHintState } from './types';

const CheckIcon = lazy(() => import('@pulse-web-ui/icons/lib/lazy/check'));
const CrossIcon = lazy(() => import('@pulse-web-ui/icons/lib/lazy/close'));

interface FieldValidationHintProps {
  text: string;
  state?: FieldValidationHintState;
}

export const FieldValidationHint = ({
  text,
  state,
}: FieldValidationHintProps) => {
  const theme = useTheme();

  return (
    <Hint $state={state}>
      <IconContainer>
        <Suspense>
          {state === FieldValidationHintState.VALID && (
            <CheckIcon
              width={20}
              viewBox='0 0 36 36'
              color={theme.colors.icon.success}
            />
          )}
          {state === FieldValidationHintState.INVALID && (
            <CrossIcon
              width={20}
              viewBox='0 0 28 28'
              color={theme.colors.icon.error}
            />
          )}
          {state === FieldValidationHintState.DEFAULT && <BulletIcon />}
        </Suspense>
      </IconContainer>
      {text}
    </Hint>
  );
};
